import React from "react";
import "../../Styles/Taetigkeitsbericht/taetigkeitsbericht.css";
import {Button, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faFilePdf,

} from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import moment from "moment";




const AppWebReportStundenActionButtonsComponent = (props) => {

    async function handleExportClick() {
        createTReport()
    }


    function emptyTable(doc, y) {
        doc.autoTable({
            margin: 25,
            startY: y,
            headStyles: {
                cellHeight: "auto",
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0],
            },
            head: [['-']],
            body: [],
        });
    }

    function addMaterialTable(doc, materialData) {
        console.log(materialData, 777)
        if (materialData === []) {
            emptyTable(doc, 32)
        } else {
            let columns = [
                {title: "Position", dataKey: "Position"},
                {title: "Bezeichnung", dataKey: "Bezeichnung"},
                {title: "Einheit", dataKey: "Einheit"},
                {title: "Anzahl", dataKey: "Anzahl"},
                {title: "Teilaufmaß", dataKey: "Teilaufmas"},
            ];
            let rows = [];
            materialData.forEach((material) => {
                let materialInfo = {}
                materialInfo.Position = material.position
                materialInfo.Bezeichnung = material.description
                if (material.unit === "㎡" || material.unit === "m²") {
                    materialInfo.Einheit = "m²"
                } else if (material.unit === "㎥" || material.unit === "m³") {
                    materialInfo.Einheit = "m³"
                } else {
                    materialInfo.Einheit = material.unit
                }
                materialInfo.Anzahl = material.menge
                materialInfo.Teilaufmas = material.aufmas
                rows.push(materialInfo);
            });
            doc.autoTable(columns, rows, {
                margin: 25,
                startY: 32,
                theme: 'grid',
                showHeader: 'everyPage',
                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                style: {overflowColumns: 'linebreak'},
                // Override the default above for the text column
                columnStyles: {
                    Teilmas: {overflow: 'linebreak'},
                    Position: {overflow: 'ellipsize', cellWidth: 'wrap'},
                    Einheit: {overflow: 'ellipsize', cellWidth: 15},
                    Anzahl: {overflow: 'ellipsize', cellWidth: 15},
                    Bezeichnung: {overflowColumns: 'linebreak', cellWidth: 30}
                },
                didParseCell: function (hookData) {
                    /*if (
                        (hookData.section === "body" && hookData.column.dataKey === "Teilaufmas")
                    ) {
                        hookData.cell.styles.minCellHeight = hookData.cell.text.length * 9
                    }*/

                    if
                    (hookData.section === "body" && (hookData.column.dataKey === "Teilaufmas"
                        || hookData.column.dataKey === "Bezeichnung")
                    ) {
                        console.log(doc.getTextWidth(hookData.cell.raw))
                        hookData.cell.styles.minCellHeight = doc.getTextWidth(hookData.cell.raw) / 3
                    }

                },
            })
        }
    }

    function addDevicesTable(doc, deviceData) {

        if (deviceData.length === 0) {
            emptyTable(doc, doc.lastAutoTable.finalY + 12)
        } else {
            let deviceHead = [];
            deviceHead.push("Name");

            let deviceBody = [];
            deviceData.forEach((device) => {
                let deviceInfo = Object.values(device).slice(1, 2);
                deviceBody.push(deviceInfo);
            });

            doc.autoTable({
                margin: 25,
                startY: doc.lastAutoTable.finalY + 12,
                theme: 'grid',
                /*headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 0,
                    lineWidth: 0.2,
                    textColor: [0, 0, 0]
                },*/
                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
                head: [deviceHead],
                body: deviceBody
            });
        }
    }

    async function getTaetigkeitenCDNImages(taetigkeitenData) {

        // let theCDNImages = [];
        let retrievedImagesInner = [];

        if (taetigkeitenData !== undefined) {
            await Promise.all(taetigkeitenData?.map(async (item) => {
//                let retrievedImagesInner = [];
                await Promise.all(item.pictures.map(async (itemInner) => {
                    /*const response = await fetch(
                        "https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/getpresignedurl",
                        {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json',
                            },
                            body: JSON.stringify({"data": {"object_path": itemInner.url}}),
                        })*/
                    const response = await getSignedUrl(itemInner)

                    const data = await response.json();
                    data.description = item.description
                    retrievedImagesInner.push(data);
                }));
                return retrievedImagesInner;
            }))
            /*.then((values) => {
            for (const innerARR of values) {
                let x = innerARR.map((item) => {
                    return item.url;
                });
                theCDNImages.push(x)
            }
        })*/;
        }
        // return theCDNImages
        let imagesList = await modifydataforimage(retrievedImagesInner)
        return imagesList

    }

    async function getCDNImages(verortungData) {

        let theCDNImages = [];
        let theCDNImagesURLs = []

        if (verortungData !== undefined) {


            theCDNImages = await Promise.all(verortungData?.map(async (item) => {

                /*const response = await fetch("https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/getpresignedurl", {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                    },
                    body: JSON.stringify({"data": {"object_path": item.url}})
                })*/
                const response = await getSignedUrl(item)
                let d = await response.json()

                return d

            }));

//            theCDNImages.forEach((item) => theCDNImagesURLs.push(item.url))
            theCDNImages.forEach((item) => {
                let singleImage = {}
                singleImage.url = item.url
                singleImage.description = "Verortung"
                theCDNImagesURLs.push(singleImage)
            })

        }

        let images = await modifydataforimage(theCDNImagesURLs)
        //return theCDNImagesURLs
        return images
    }

    function getImageDimensions(url) {
        return new Promise((resolve, reject) => {
            // Create a new Image object
            const img = new Image();

            // Set the image source to the provided URL
            img.src = url;

            // Define the callback function to be executed when the image is loaded
            img.onload = function () {
                // Resolve the promise with the image dimensions
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            };

            // Handle errors in case the image fails to load
            img.onerror = function (error) {
                // Reject the promise with an error object
                reject({
                    error: "Failed to load image",
                    details: error
                });
            };
        });
    }

    async function modifydataforimage(theCDNImagesURLs) {
        let images = await Promise.all(
            theCDNImagesURLs.map(async (image) => {
                try {
                    //console.log(image,image.replace("http", "https"))
                    const dimensions = await getImageDimensions(image.url);
                    return {
                        link: image.url,
                        description: image.description,
                        ...dimensions
                    };
                } catch (error) {
                    return {
                        error
                    };
                }
            })
        );
        return images
    }

    async function retrieveVerortungImages(i) {
        let reportData = i
        let verortungData = reportData.verortung;
        return await getCDNImages(verortungData);
    }

    async function addVerortungImages(doc, i) {

        await retrieveVerortungImages(i).then(images => {

            printImages(doc, "Verortungen der Tätigkeit(en)", images)
        })
    }


    function printImages(doc, mainDesc, images) {
        if (mainDesc !== "Tätigkeiten") {
            for (let i = 0; i < images.length; i++) {
                let x = 25
                let y = 40
                let MAX_WIDTH = 180;
                let MAX_HEIGHT = 280
                ///////////////////////
                doc.addPage();
                doc.setFontSize(18);
                doc.text(mainDesc, 25, 30);
                if (mainDesc === "Tätigkeiten") {
                    doc.setFontSize(16);
                    doc.text("Beschreibung der Tätigkeit(en):", 25, 45, "left")
                    doc.text(images[i].description, 25, 55, {maxWidth: 160})
                    doc.addPage();
                    doc.setFontSize(18);
                    doc.text("Bild(er) der Taetigkeit(en)", 25, 30);
                }
                let width = images[i].width;
                let height = images[i].height;
                MAX_WIDTH = 170;
                MAX_HEIGHT = 240
                //MAX_HEIGHT = 225 - 2 * (Math.floor(doc.getTextWidth(images[i].description)) / 160);
                //y = 1 + y + 2 * (Math.floor(doc.getTextWidth(images[i].description)) / 160)

                //if(width>height){[height,width] = [width,height]}

                if (width > height) {
                    MAX_HEIGHT = 170;
                    MAX_WIDTH = 240

                    height = height * (MAX_WIDTH / width);
                    width = MAX_WIDTH;
                } else {
                    if (height > MAX_HEIGHT & height > width) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                let deg = null
                if (images[i].width > images[i].height) {
                    y = y + MAX_WIDTH - height
                    x = x + MAX_HEIGHT
                    //y = y+MAX_WIDTH
                    deg = 90
                }
                doc.addImage(images[i].link, 'PNG', x, y, width, height, undefined, 'FAST', deg);
                ///////////////////////
            }
        }

        if (mainDesc === "Tätigkeiten") {
            let headline = false
            let imagesGroup = Object.groupBy(images, e => [e.description]);
            for (const key in imagesGroup) {
                let group = imagesGroup[key]
                for (let i = 0; i < group.length; i++) {
                    let x = 25
                    let y = 40
                    let MAX_WIDTH = 180;
                    let MAX_HEIGHT = 280
                    ///////////////////////
                    doc.addPage();
                    doc.setFontSize(18);
                    if (headline) {
                        doc.text("Bild(er) der Taetigkeit(en)", 25, 30)
                    }
                    if (mainDesc === "Tätigkeiten") {

                        if (i === 0) {
                            headline = true
                            doc.setFontSize(16);
                            doc.text("Beschreibung der Tätigkeit(en):", 25, 30, "left")
                            doc.text(group[i].description, 25, 45, {maxWidth: 160})
                            doc.addPage();
                            doc.text("Bild(er) der Taetigkeit(en)", 25, 30);

                        }
                    }
                    let width = group[i].width;
                    let height = group[i].height;
                    MAX_WIDTH = 170;
                    MAX_HEIGHT = 240

                    if (width > height) {
                        MAX_HEIGHT = 170;
                        MAX_WIDTH = 240

                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    } else {
                        if (height > MAX_HEIGHT & height > width) {
                            width = width * (MAX_HEIGHT / height);
                            height = MAX_HEIGHT;
                        }
                    }
                    let deg = null
                    if (group[i].width > group[i].height) {
                        y = y + MAX_WIDTH - height
                        x = x + MAX_HEIGHT
                        deg = 90
                    }
                    doc.addImage(group[i].link, 'PNG', x, y, width, height, undefined, 'FAST', deg);
                    ///////////////////////
                }
            }
        }
    }

    function addTEmployee(doc, coworkers, yposition) {

        if (coworkers.length === 0) {
            emptyTable(doc, yposition + 12)
        } else {

            let employeeHead = [];
            employeeHead.push("Vorname");
            employeeHead.push("Nachname");
            employeeHead.push("Rolle");
            employeeHead.push("Arbeitszeit");

            let employeeBody = [];
            coworkers.forEach((employee) => {
                let employeeInfo = Object.values(employee).slice(1, 4);
                let workHours = employee.workHours.startTime.substring(0, 5) + " - " + employee.workHours.endTime.substring(0, 5);
                employeeInfo.push(workHours);
                employeeBody.push(employeeInfo);
            });

            doc.autoTable({
                margin: 25,
                startY: yposition + 12,
                theme: 'grid',
                /*headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 0,
                    lineWidth: 0.2,
                    textColor: [0, 0, 0]
                },*/
                headStyles: {
                    cellHeight: "auto",
                    fillColor: [255, 255, 255],
                    lineColor: 200,
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                },
                bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
                head: [employeeHead],
                body: employeeBody
            });
        }
    }

    function addDateTable(doc, anmeldungData, abmeldungData, yposition) {

        let dateTableHead = [];
        dateTableHead.push(" ");
        dateTableHead.push("Datum");
        dateTableHead.push("Durch");

        let dateTableBody = [];
        dateTableBody.push([
            "Auftrag erteilt",
            moment(props.stundenReportData.metaAndProjectData.metaData.date).format("DD.MM.YYYY"),
            abmeldungData.auftraggeber_registeration[0].firstName + "," +
            abmeldungData.auftraggeber_registeration[0].firstName
        ])
        dateTableBody.push([
            "Freigabe Anmeldung",
            moment(anmeldungData.auftraggeber_confirmation[0].confirmationDate).format("DD.MM.YYYY"),
            anmeldungData.auftraggeber_confirmation[0].firstName + "," +
            anmeldungData.auftraggeber_confirmation[0].lastName
        ])
        dateTableBody.push([
            "Freigabe Ausführung",
            moment(abmeldungData.auftraggeber_done[0].confirmationDate).format("DD.MM.YYYY"),
            abmeldungData.auftraggeber_done[0].firstName + "," +
            abmeldungData.auftraggeber_done[0].lastName
        ])

        doc.autoTable({
            margin: 25,
            startY: yposition + 5,
            theme: 'grid',
            headStyles: {
                cellHeight: "auto",
                fillColor: [255, 255, 255],
                lineColor: 200,
                lineWidth: 0.1,
                textColor: [0, 0, 0],
            },
            bodyStyles: {lineColor: 200, lineWidth: 0.1, textColor: [0, 0, 0]},
            head: [dateTableHead],
            body: dateTableBody
        });

    }

    async function addTaetigkeitenData(doc, i) {
        let taetigkeitenData = [i]

        let imagesOutArray = await getTaetigkeitenCDNImages(taetigkeitenData)

        let descriptions = [];
        taetigkeitenData.forEach((taetigkeit) => {
            let description = taetigkeit.description;
            descriptions.push(description);
        });
        printImages(doc, "Tätigkeiten", imagesOutArray)
    }

    async function addSignature(doc, url, y) {
        let signImg = {}
        signImg.url = url
        let response = await getSignedUrl(signImg)
        response = await response.json()
        doc.addImage(response.url, 'PNG', 25, y, 60, 40);
    }

    async function getSignedUrl(itemInner) {
        return await fetch(
            "https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/getpresignedurl",
            {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({"data": {"object_path": itemInner.url}}),
            })
    }

    async function createAnmeldungPages(doc, anmeldungData,projectData) {
        let auftraggeberAddresse = projectData.auftraggeberAddress
        let planerAddresse = projectData.planerAddress
        let projectLead = projectData.projectLeadDetails[0]

        doc.setFont("Calibri", "normal", "");
        doc.setFontSize(12)
        doc.text(auftraggeberAddresse.firma, 25, 30, "left",);
        let data = auftraggeberAddresse.streetName + ", " + auftraggeberAddresse.houseNumber
        doc.text(data, 25, 35, "left",)
        data = auftraggeberAddresse.cityName + ", " + auftraggeberAddresse.postalCode
        doc.text(data, 25, 40, "left",);

        doc.text(planerAddresse.firma, 110, 30, "left",);
        data = planerAddresse.streetName + ", " + planerAddresse.houseNumber
        doc.text(data, 110, 35, "left",)
        data = planerAddresse.cityName + ", " + planerAddresse.postalCode
        doc.text(data, 110, 40, "left",);
        let s = 0



        doc.setFontSize(10)
        doc.text("Fax: " + auftraggeberAddresse.fax, 25, 50+s+10, "left",)
        doc.text("E-mail: " + auftraggeberAddresse.email, 25, 54+s+10, "left",)
        doc.text("E-mail: " + planerAddresse.email, 110, 50+s+10, "left",)

        doc.text("Auftraggsnumer", 25, 70+s, "left",)
        doc.text(projectData.customerIdentificator, 25, 74+s, "left",)

        doc.text("Ansprechpartner", 55, 70+s, "left",)
        doc.text(projectLead.firstName + " " + projectLead.lastName, 55, 74+s, "left",)

        doc.text("Telefonnummer", 100, 70+s, "left",)
        doc.text(projectLead.telefon, 100, 74+s, "left",)

        doc.text("E-mail", 130, 70+s, "left",)
        doc.text(projectLead.email, 130, 74+s, "left",)

        doc.text("Datum", 160, 70+s, "left",);
        doc.text(moment().format("DD.MM.YYYY"), 160, 74+s, "left",)

        doc.setFontSize(12)
        doc.text(projectData.customerReference, 25, 85+s, "left",)

        doc.setFontSize(14)
        data = "Stundenlohnanmeldung Nr. " + anmeldungData.stundenlohnCounter + " - "
            + anmeldungData.stundenlohnTitle
        doc.text(data, 25, 98+s, "left",)

        doc.setFontSize(12);
        doc.text("Sehr geehrte Damen und Herren,", 25, 105+s, "left")


        data = "gemäß Aufforderung von " + anmeldungData.auftraggeber_registeration[0].firstName
            + " " + anmeldungData.auftraggeber_registeration[0].lastName +
            " sollen wir für das oben gennante Bauvorhaben Stundenlohnarbeiten durchführen." +
            " Gemäß § 2 Nr. 10 der VOB, Teil B, und oben gennante Vertrag werden Zusatzarbeiten " +
            "nur für den Fall vergütet, dass sie vor Beginn der Arbeiten mit dem Auftraggeber " +
            "ausdrücklich vereinbart worden sind. Wir machen darauf aufmerksam, dass folgende " +
            "Leistungen nicht in den Einheitspreisen enthalten sind und demnach als " +
            "Stundenlohnarbeiten abgerechnet werden. Die Stundenlohnnachweise werden " +
            "Ihnen bei den jewelligen Bausitzungen vorgelegt:"

        doc.text(data, 25, 115+s, {maxWidth: 165, align: "justify"})
        doc.internal.write(0, "Tw")

        let text = "-"
        if (anmeldungData.taetigkeit_angemeldet.length !== 0) {
            text = anmeldungData.taetigkeit_angemeldet[0].description
        }
        doc.text(text, 25, 165+s, {maxWidth: 165, align: "justify"})

        doc.internal.write(0, "Tw")


        data = "Den Aufwand für diese Zusatzleistungen schätzen wir zum Nachweis auf ca:"
        doc.text(data, 25, 175+s)
        doc.internal.write(0, "Tw")

        doc.setFontSize(12);
        doc.text("Meister:", 25, 185+s)
        doc.text(anmeldungData.estimation.roles.meister + "/Std", 100, 185+s)

        doc.text("bauleitender Monteur:", 25, 193+s)
        doc.text(anmeldungData.estimation.roles.bauleitender_monteur + "/Std", 100, 193+s)

        doc.text("Geselle:", 25, 200+s)
        doc.text(anmeldungData.estimation.roles.geselle + "/Std", 100, 200+s)

        doc.text("Lehrling:", 25, 208+s)
        doc.text(anmeldungData.estimation.roles.lehrling + "/Std", 100, 208+s)

        doc.text("Helfer:", 25, 216+s)
        doc.text(anmeldungData.estimation.roles.lehrling + "/Std", 100, 216+s)

        doc.setFontSize(12);
        doc.text("Materialkosten:", 25, 231+s)
        doc.text(anmeldungData.cost_estimation.material + "/€", 100, 231+s, "left");

        doc.text("Vorhaltekosten:", 25, 239+s)
        doc.text(anmeldungData.cost_estimation.vorhaltung + "/€", 100, 239+s, "left");

        doc.text("Nebenkosten:", 25, 247+s)
        doc.text(anmeldungData.cost_estimation.neben + "/€", 100, 247+s, "left");

        doc.text("Fahrtkosten:", 25, 255+s)
        doc.text(anmeldungData.cost_estimation.fahrt + "/€", 100, 255+s, "left");






        doc.addPage()
        data = "Die vorgenannten Sätze verstehen sich zzgl. der bei" +
            " Rechnungsstellung gültigen MwSt. Für evtl. gewünschte" +
            " oder erforderliche Überstunden wird ein Zuschlag von " +
            anmeldungData.cost_estimation.ueberstunden + "%" + " auf die genannten Löhne berechnet."

        doc.text(data, 25, 31, {maxWidth: 165, align: "justify"})
        doc.internal.write(0, "Tw")

        data = "Wir bitten Sie, uns das neue Preisangebot aus Gründen der " +
            "Rechtsklarheit bis " + (moment(anmeldungData.cost_estimation.frist).format("DD.MM.YYYY")) + " zu bestätigen, um Verzögerungen " +
            "des Bauablaufs zu vermeiden."
        doc.text(data, 25, 55, {maxWidth: 165, align: "justify"})
        doc.internal.write(0, "Tw")

        data = "Wir werden die Vergütung nach der vertraglich getroffen Vereinbarung abrechnen." +
            " Senden Sie bitte ein unterschriebenes Exemplar an uns zurück. Alternativ können Sie uns über die vorgenannten Leistungen auch ein " +
            "NachtragsLeistungsverzeichnis zukommen lassen."
        doc.text(data, 25, 72, {maxWidth: 165, align: "justify"})
        doc.internal.write(0, "Tw")


        doc.text("Mit freundlichen Grüßen", 25, 95)
        doc.text(projectLead.firstName + " " +
            projectLead.lastName, 25, 105)

        let signdata = anmeldungData.auftraggeber_registeration[0]
        let signurl = signdata.pre_signurl
        if (
            signdata.pre_sign === "yes" &&
            signurl !== ""
        ) {
            doc.setFontSize(14)
            doc.text("Anerkannt/Freigabe", 25, 117)
            doc.setFontSize(12)
            await addSignature(doc, signurl, 120)
            doc.text(signdata.firstName + " " +
                signdata.lastName + ", " + "am " +
                moment( "DD-MM-YYYY").format("DD.MM.YYYY"), 25, 170)
        } else {
            //if(abmeldungData !=={} || abmeldungData !==undefined){
            if (props.type === "Stunden-Abmeldung") {
                doc.text("Dokumentation Freigabe", 25, 132)
                doc.setFontSize(12);
                doc.text("Durch: " + anmeldungData.auftraggeber_confirmation[0].firstName + " " +
                    anmeldungData.auftraggeber_confirmation[0].lastName, 25, 140)
                doc.text("Am: "
                    + moment(anmeldungData.auftraggeber_confirmation[0].confirmationDate, "DD-MM-YYYY").format("DD.MM.YYYY"), 25, 148)
                doc.text("Erhalten mittels: " + anmeldungData.auftraggeber_confirmation[0].confirmationType, 25, 156)
            } else {
                doc.setFontSize(14);
                doc.text("Ort,Datum", 25, 138)
                doc.line(50, 138, 130, 138)
                doc.text("Auftraggeber/Stempel", 25, 155)
                doc.line(75, 155, 130, 155)
            }
        }
        doc.setFontSize(12);
        doc.text("Anhang", 25, 180)
        doc.text("-Verortungen der Tätigkeit(en)", 25, 187)
        doc.text("-Beschreibung der Tätigkeit(en):", 25, 194)
        doc.text("-Bild(er) der Taetigkeit(en)", 25, 201)
        doc.text("-Material", 25, 208)
        doc.text("-Betriebsmittel", 25, 215)
        doc.setFontSize(12);
        for (let i in anmeldungData.taetigkeit_angemeldet) {
            await addVerortungImages(doc, anmeldungData.taetigkeit_angemeldet[i]);
            await addTaetigkeitenData(doc, anmeldungData.taetigkeit_angemeldet[i]);
        }
        doc.addPage()
        doc.text("Material", 25, 30, "left");
        addMaterialTable(doc, anmeldungData.material_angemeldet);
        doc.text("Betriebsmittel", 25, doc.lastAutoTable.finalY + 10, "left");
        addDevicesTable(doc, anmeldungData.material_geraet);
    }


    async function createTReport() {
        console.log(1212111111)
            let anmeldungData = props.stundenReportData.anmeldungData
            let abmeldungData = props.stundenReportData.abmeldungData
            let title = ""
            let projectData=props.stundenReportData.metaAndProjectData.projectData
            let projectName = projectData.projectName
            let projectLead = projectData.projectLeadDetails[0]



            const doc = new jsPDF({orientation: "p", lineHeight: 1.5}, "", "", true);
            let pdfName = "stunden.pdf"
            if (props.type==="Stunden-Anmeldung")
            {
                ///////////////////
                await createAnmeldungPages(doc, anmeldungData,projectData)
                //////////////////////////////////////
                pdfName = moment().format("YYYYMMDD") + "_STA_" + projectName + "_" + anmeldungData.stundenlohnCounter
                for (let i = 1; i <= doc.getNumberOfPages(); i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    let text = pdfName
                    //let text = "Stundenlohnanmeldung Nr. " + anmeldungData.stundenlohnCounter + " - "
                    //    + anmeldungData.stundenlohnTitle
                    doc.text(text, 25, doc.internal.pageSize.height - 10,);
                    doc.text(doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10,
                        "Seite: " + i.toString() + " von " + doc.getNumberOfPages().toString());
                }
            }
            else if ((props.type==="Stunden-Abmeldung"))
            {
                title = "Stundenlohnausführung Nr. " + abmeldungData.stundenlohnCounter +
                    " | " + abmeldungData.stundenlohnTitle
                doc.setFont("Calibri", "normal", "");
                doc.setFontSize(14)
                doc.text(title, 25, 30, "left",);
                const taetigkeitTextWidth = doc.getTextWidth(title);
                doc.line(25, 31, 25 + taetigkeitTextWidth, 31)
                let s = 0

                doc.setFontSize(12)
                doc.text("Bauvorhaben: " + projectName, 25, 45+s, "left",);
                doc.text("Auftragsnummer: " + projectData.projectNumber, 25, 55+s, "left",);
                doc.text("Referenz: " + projectData.customerReference, 25, 65+s, "left",);
                addDateTable(doc, anmeldungData, abmeldungData, 70+s)
                doc.setFontSize(14)
                doc.text("Arbeitszeit", 25, 120+s, "left");
                doc.setFontSize(12)
                addTEmployee(doc, abmeldungData.coworkers, 120+s);
                for (let i in abmeldungData.taetigkeit_abgemeldet) {
                    await addVerortungImages(doc, abmeldungData.taetigkeit_abgemeldet[i]);
                    await addTaetigkeitenData(doc, abmeldungData.taetigkeit_abgemeldet[i]);
                }
                doc.addPage()
                doc.text("Material", 25, 30, "left");
                addMaterialTable(doc, abmeldungData.material_abgemeldet);
                doc.text("Betriebsmittel", 25, doc.lastAutoTable.finalY + 10, "left");
                addDevicesTable(doc, abmeldungData.material_geraet);
                doc.setFontSize(12);

                doc.text("Mit freundlichen Grüßen", 25, doc.lastAutoTable.finalY + 10)
                doc.text(projectLead.firstName + " " +
                    projectLead.lastName, 25, doc.lastAutoTable.finalY + 20)

                doc.setFontSize(14)
                doc.text("Anerkannt/Freigabe", 25, doc.lastAutoTable.finalY + 32)
                doc.setFontSize(12)
                let signdata = abmeldungData.auftraggeber_registeration[0]
                let signurl = abmeldungData.creatorSignature
                if (signdata.pre_sign === "yes" && signurl !== "") {
                    await addSignature(doc, signurl, doc.lastAutoTable.finalY + 35)
                    doc.text(signdata.firstName + " " +
                        signdata.lastName + ", " + "am " +
                        moment( "DD-MM-YYYY").format("DD.MM.YYYY"), 25, doc.lastAutoTable.finalY + 75)
                } else {
                    doc.setFontSize(14);
                    doc.text("Ort,Datum", 25, doc.lastAutoTable.finalY + 53)
                    doc.line(50, doc.lastAutoTable.finalY + 53, 130, doc.lastAutoTable.finalY + 53)
                    doc.text("Auftraggeber/Stempel", 25, doc.lastAutoTable.finalY + 70)
                    doc.line(75, doc.lastAutoTable.finalY + 70, 130, doc.lastAutoTable.finalY + 70)
                }
                doc.setFontSize(12);
                doc.text("Anhang", 25, doc.lastAutoTable.finalY + 85)
                doc.text("-Anmeldung der Stundenlohnarbeit", 25, doc.lastAutoTable.finalY + 95)

                doc.addPage()
                ////printing anmeldung report again//
                await createAnmeldungPages(doc, anmeldungData,projectData)
                /////////////////////////////////////////////////
                pdfName = moment().format("YYYYMMDD") + "_STB_" + projectName + "_" + abmeldungData.stundenlohnCounter
                for (let i = 1; i <= doc.getNumberOfPages(); i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    let text = pdfName
                    doc.text(text, 25, doc.internal.pageSize.height - 10)
                    doc.text(doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10,
                        "Seite: " + i.toString() + " von " + doc.getNumberOfPages().toString());
                }
            }
            console.log(12121)
                doc.save(pdfName + ".pdf")
        }



    return (
        <Row className="justify-content-between">
            <Col className="ml-4">
            </Col>
            <Col className="ml-4" style={{textAlign: "center"}}>
            </Col>
            <Col className="text-right mr-5">
                <Button
                    //disabled={!props.isChange}
                    title="Export"
                    className="handwai-btn-create mr-4"
                    onClick={async()=>{
                        await handleExportClick()
                    }}
                >
                    <FontAwesomeIcon icon={faFilePdf}/>
                </Button>
            </Col>

        </Row>
    )
        ;

}


export default AppWebReportStundenActionButtonsComponent;